export default "/images/vendor/@coreui/icons/svg/flag/cif-bj.svg?d7e0c53d3dd43386a891bb48264c55de";